// extracted by mini-css-extract-plugin
export default {"input_container":"NumericInput_input_container__nZqbd","error_msg":"NumericInput_error_msg__IKRyc"};